var _Variants$Highlight, _Variants$Negative, _Variants$Positive, _Variants$Warning, _Variants$Information, _bannerConfig;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Icon } from '@doordash/design-language';
import { Variants, Types } from './types';
export var bannerConfig = (_bannerConfig = {}, _defineProperty(_bannerConfig, Variants.Highlight, (_Variants$Highlight = {}, _defineProperty(_Variants$Highlight, Types.Default, {
  foreground: 'BannerHighlightDefaultForeground',
  iconType: Icon.Types.PromoLine,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_Variants$Highlight, Types.Emphasis, {
  foreground: 'BannerHighlightEmphasisForeground',
  iconType: Icon.Types.PromoFill,
  secondaryButton: 'BannerHighlightEmphasisForeground'
}), _defineProperty(_Variants$Highlight, Types.Subdued, {
  foreground: 'BannerHighlightSubduedForeground',
  iconType: Icon.Types.PromoLine,
  secondaryButton: 'ButtonFabForeground'
}), _Variants$Highlight)), _defineProperty(_bannerConfig, Variants.Negative, (_Variants$Negative = {}, _defineProperty(_Variants$Negative, Types.Default, {
  foreground: 'BannerNegativeDefaultForeground',
  iconType: Icon.Types.ErrorFill,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_Variants$Negative, Types.Emphasis, {
  foreground: 'BannerNegativeEmphasisForeground',
  iconType: Icon.Types.ErrorFill,
  secondaryButton: 'BannerNegativeEmphasisForeground'
}), _defineProperty(_Variants$Negative, Types.Subdued, {
  foreground: 'BannerNegativeSubduedForeground',
  iconType: Icon.Types.ErrorLine,
  secondaryButton: 'ButtonFabForeground'
}), _Variants$Negative)), _defineProperty(_bannerConfig, Variants.Positive, (_Variants$Positive = {}, _defineProperty(_Variants$Positive, Types.Default, {
  foreground: 'BannerPositiveDefaultForeground',
  iconType: Icon.Types.CheckCircleLine,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_Variants$Positive, Types.Emphasis, {
  foreground: 'BannerPositiveEmphasisForeground',
  iconType: Icon.Types.CheckCircleFill,
  secondaryButton: 'BannerPositiveEmphasisForeground'
}), _defineProperty(_Variants$Positive, Types.Subdued, {
  foreground: 'BannerPositiveSubduedForeground',
  iconType: Icon.Types.Check,
  secondaryButton: 'ButtonFabForeground'
}), _Variants$Positive)), _defineProperty(_bannerConfig, Variants.Warning, (_Variants$Warning = {}, _defineProperty(_Variants$Warning, Types.Default, {
  foreground: 'BannerWarningDefaultForeground',
  iconType: Icon.Types.WarningFill,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_Variants$Warning, Types.Emphasis, {
  foreground: 'BannerWarningEmphasisForeground',
  iconType: Icon.Types.WarningFill,
  secondaryButton: 'BannerWarningEmphasisForeground'
}), _defineProperty(_Variants$Warning, Types.Subdued, {
  foreground: 'BannerWarningSubduedForeground',
  iconType: Icon.Types.WarningLine,
  secondaryButton: 'ButtonFabForeground'
}), _Variants$Warning)), _defineProperty(_bannerConfig, Variants.Informational, (_Variants$Information = {}, _defineProperty(_Variants$Information, Types.Default, {
  foreground: 'BannerInformationalDefaultForeground',
  iconType: Icon.Types.InfoCircleLine,
  secondaryButton: 'ButtonFabForeground'
}), _defineProperty(_Variants$Information, Types.Emphasis, {
  foreground: 'BannerInformationalEmphasisForeground',
  iconType: Icon.Types.InfoCircleFill,
  secondaryButton: 'BannerInformationalEmphasisForeground'
}), _defineProperty(_Variants$Information, Types.Subdued, {
  foreground: 'BannerInformationalSubduedForeground',
  iconType: Icon.Types.InfoCircleLine,
  secondaryButton: 'ButtonFabForeground'
}), _Variants$Information)), _bannerConfig);
export var getIconType = function getIconType(_ref) {
  var variant = _ref.variant,
      type = _ref.type,
      iconType = _ref.iconType;

  if (variant === Variants.Negative || variant === Variants.Warning) {
    return bannerConfig[variant][type].iconType;
  }

  return iconType || bannerConfig[variant][type].iconType;
};